function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useRef, useState, useMemo, useEffect, useContext, useCallback } from 'react';
import './Modal.css';
import AriaModal from 'react-aria-modal';
import { injectIntl } from 'react-intl';
import IconButton from '../../Buttons/IconButton/IconButton';
import Icon from '../../Icons/Icon/Icon';
import { ReactComponent as CloseX } from '../../../icons/CloseX/CloseX.svg';
import whitelistProps from '../../utils/whitelistProps';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import { formatI18n } from '../../I18n/I18n/I18n';
import cs from 'classnames';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import en from './locales/Modal.en.json';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import ThemeContext from '../../ThemeContext';
import useStickyBottom from '../../Drawer/useStickyBottom';
var whitelist = whitelistProps();
var messages = normalizeLocaleData(en, '@dm/components.modal');
function useFocusTrapOptions(refocusEl) {
  var timeoutId = useRef(null);
  return useMemo(function () {
    if (refocusEl) {
      return {
        onDeactivate: function onDeactivate() {
          clearTimeout(timeoutId.current);
          timeoutId.current = setTimeout(function () {
            var sel = typeof refocusEl === 'function' ? refocusEl() : refocusEl;
            var ref = document.querySelector(sel);
            if (ref) {
              ref.focus();
            }
          }, 0);
        }
      };
    } else {
      return {};
    }
  }, [refocusEl]);
}
function useSessionTimeoutDetection() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  useEffect(function () {
    var shown = function shown() {
      return setActive(true);
    };
    var hidden = function hidden() {
      return setActive(false);
    };
    if (window.$) {
      var win = window.$(window);
      win.on('shown.dmModal', shown);
      win.on('hidden.dmModal', hidden);
    }
    return function () {
      if (window.$) {
        var _win = window.$(window);
        _win.off('shown.dmModal', shown);
        _win.off('hidden.dmModal', hidden);
      }
    };
  }, [setActive]);
  return active;
}
function Modal(_ref) {
  var _ref$alert = _ref.alert,
    alert = _ref$alert === void 0 ? false : _ref$alert,
    className = _ref.className,
    _ref$scrollDisabled = _ref.scrollDisabled,
    scrollDisabled = _ref$scrollDisabled === void 0 ? true : _ref$scrollDisabled,
    mounted = _ref.mounted,
    titleText = _ref.titleText,
    titleId = _ref.titleId,
    children = _ref.children,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '26.9230769em' : _ref$maxWidth,
    _ref$escapeExits = _ref.escapeExits,
    escapeExits = _ref$escapeExits === void 0 ? true : _ref$escapeExits,
    _ref$includeCloseX = _ref.includeCloseX,
    includeCloseX = _ref$includeCloseX === void 0 ? true : _ref$includeCloseX,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position,
    onExit = _ref.onExit,
    _ref$modifier = _ref.modifier,
    modifier = _ref$modifier === void 0 ? '' : _ref$modifier,
    _ref$refocusEl = _ref.refocusEl,
    refocusEl = _ref$refocusEl === void 0 ? '' : _ref$refocusEl,
    intl = _ref.intl,
    attrs = _objectWithoutProperties(_ref, ["alert", "className", "scrollDisabled", "mounted", "titleText", "titleId", "children", "maxWidth", "escapeExits", "includeCloseX", "position", "onExit", "modifier", "refocusEl", "intl"]);
  var focusTrapOptions = useFocusTrapOptions(refocusEl);
  var theme = useContext(ThemeContext);
  var timeoutActive = useSessionTimeoutDetection();
  var footerRef = useRef(null);
  var contentRef = useRef(null);
  var handleRef = useCallback(function (displaced) {
    if (displaced && displaced.container) {
      contentRef.current = displaced.container.querySelector('._modal__dialog');
    }
  }, [contentRef]);
  useStickyBottom(contentRef, footerRef);
  useEffect(function () {
    if (mounted && scrollDisabled) {
      var el = document.documentElement;
      var saved = el.style.overflow;
      el.style.overflow = 'hidden';
      return function () {
        el.style.overflow = saved;
      };
    }
  }, [scrollDisabled, mounted]);
  return mounted ? /*#__PURE__*/React.createElement(AriaModal, Object.assign({
    alert: alert,
    scrollDisabled: false,
    titleText: formatI18n(intl, titleText),
    titleId: titleId,
    includeDefaultStyles: false,
    escapeExits: escapeExits,
    underlayClickExits: !alert,
    underlayClass: "_dm-modal".concat(theme === 'ripple' ? '--ripple' : ''),
    focusTrapPaused: timeoutActive,
    focusTrapOptions: focusTrapOptions,
    ref: handleRef,
    dialogClass: cs(className, "_modal__dialog _modal__dialog--".concat(position, " auto-modal-dialog"), "_modal__dialog--".concat(theme), _defineProperty(_defineProperty({}, "_modal__dialog--".concat(modifier), modifier), "auto-modal-dialog--".concat(modifier), modifier)),
    dialogStyle: {
      maxWidth: maxWidth
    },
    focusDialog: true,
    onExit: onExit
  }, whitelist(attrs)), includeCloseX && /*#__PURE__*/React.createElement(AdditionalIntl, {
    messages: messages,
    path: "Modal/Modal/locales/Modal",
    namespace: "@dm/components.modal"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "_dm-button--close-modal _dm-button--close-modal--".concat(theme),
    onClick: onExit
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: "@dm/components.modal.close",
    hideLabel: true
  }), /*#__PURE__*/React.createElement(Icon, {
    height: 18,
    width: 18
  }, /*#__PURE__*/React.createElement(CloseX, {
    height: 18,
    width: 18
  })))), typeof children === 'function' ? children(footerRef) : children) : null;
}
export default injectIntl(Modal);